import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { toggleSkipDiceAnimation } from '@/redux/reducers/diceGameReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

const SkipAnimationToggle: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const skipAnimation = useAppSelector((state) => state.diceGame.skipAnimation);

  return (
    <label className={css.skipLabel}>
      <input
        type="checkbox"
        checked={skipAnimation}
        onChange={() => dispatch(toggleSkipDiceAnimation())}
        className={css.skipCheckbox}
      />
      <span className={css.skipCustom} data-checked={skipAnimation}>
        {skipAnimation && (
          <img src="/img/bingo/arrow-go.svg" alt="" className={css.checkMark} />
        )}
      </span>
      <span className={css.skipText}>{t('Skip animation')}</span>
    </label>
  );
};

export { SkipAnimationToggle };
